import { InlineText1 } from '@cian/ui-kit';
import cs from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { IBuilder, ISpecificationItem } from '../../types/newbuildingSpecifications';
import { Link } from '../Link';

export const NewbuildingSpecifications = ({
  specifications,
  status,
  developer,
}: {
  specifications: ISpecificationItem[];
  status: string;
  developer: IBuilder | null;
}) => {
  return (
    <ul className={cs(styles['container'])}>
      <li className={styles['item']}>
        <div className={styles['title']}>
          <InlineText1 color="gray60_100">Сдача комплекса</InlineText1>
        </div>
        <InlineText1>{status}</InlineText1>
      </li>
      {developer && developer.url && (
        <li className={cs(styles['item'])}>
          <div className={styles['title']}>
            <InlineText1 color="gray60_100">Застройщик</InlineText1>{' '}
          </div>
          <Link target="_blank" url={developer.url}>
            {developer.name}
          </Link>
        </li>
      )}
      {specifications.map(item => (
        <li key={item.title} className={cs(styles['item'])}>
          <div className={styles['title']}>
            <InlineText1 color="gray60_100">{item.title}</InlineText1>
          </div>
          <InlineText1>{item.value || '-'}</InlineText1>
        </li>
      ))}
    </ul>
  );
};
